import { AxiosInstance } from "axios";
import {
  ProjectDataProps,
  ShowAlertProps,
} from "../../Components/common/types";
import { project } from "../../config/variables";
import { getErrorMessage } from "../errors";
import { errLog, log } from "../logger";
import { NavigateFunction } from "react-router-dom";

interface UpdateProps {
  id: string;
  updateData: ProjectDataProps;
  setShowLoader: (value: boolean) => void;
  showAlert: ShowAlertProps["showAlert"];
  closeAlert: () => void;
  api: AxiosInstance;
  fetchProjects: () => Promise<void>; //accept callback to fecth updated data
   navigate: NavigateFunction; 
}

const handleUpdate = async ({
  id,
  updateData,
  setShowLoader,
  showAlert,
  closeAlert,
  api,
  fetchProjects,
  navigate
}: UpdateProps) => {
  const url = `${project}/${id}`;
  log("Data to be updated", updateData)
  try {
    setShowLoader(true);
    const response = await api.patch(url, updateData);
    if (response.data.success) {
      showAlert(
        false,
        "Update Success",
        response.data.message,
        false,
        undefined,
        undefined,
        false
      );
      setTimeout(() => {
        closeAlert(); //close alert
        navigate("/dashboard/landing/");
        fetchProjects(); //fetch updated projects to update UI
      }, 1250);
    }
  } catch (error) {
    const errMsg = getErrorMessage(error);
    errLog("UPDATE PROJECT ERR:", errMsg);
    showAlert(true, "Update Error", errMsg, false);
  } finally {
    setShowLoader(false);
  }
};


export default handleUpdate;